export default "__VITE_ASSET__DoLRQoBQ__"